import { GridColDef } from "@mui/x-data-grid";

export const paymentMethodColumns: GridColDef[] = [
  { field: "name", headerName: "Name", flex: 1 },
];
